"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuery = void 0;
const react_router_dom_1 = require("react-router-dom");
const query_string_1 = __importDefault(require("query-string"));
const react_1 = require("react");
const useQuery = () => {
    const history = (0, react_router_dom_1.useHistory)();
    const query = (0, react_1.useMemo)(() => {
        return query_string_1.default.parse(history.location.search);
    }, [history.location.search]);
    const updateQuery = (0, react_1.useCallback)((properties, replace = false) => {
        const newQuery = replace ? properties : Object.assign(Object.assign({}, query), properties);
        history.push(history.location.pathname + '?' + query_string_1.default.stringify(newQuery));
    }, [query, history.location]);
    return [query, updateQuery];
};
exports.useQuery = useQuery;
//# sourceMappingURL=useQuery.js.map